export const EXPORT_SHIPMENTS_FILE_TYPE = {
  CSV: 'csv',
  TSV: 'tsv',
  MICROSOFT_EXCEL: 'xlsx'
}

export const EXPORT_FILE_OPTIONS = {
  ALL: 1,
  SELECTED: 2
}

export const FILE_TYPES = [
  {
    value: EXPORT_SHIPMENTS_FILE_TYPE.CSV,
    title: 'CSV'
  },
  {
    value: EXPORT_SHIPMENTS_FILE_TYPE.TSV,
    title: 'TSV'
  },
  {
    value: EXPORT_SHIPMENTS_FILE_TYPE.MICROSOFT_EXCEL,
    title: 'Microsoft Excel'
  }
];
export const DEFAULT_FILE_TYPE = FILE_TYPES[0].value;

export const MAPPING_NAME = {
  Amazon: 1,
  Rakuten: 2,
  YShip: 3,
  RakutenOld: 4,
}



// WEBPACK FOOTER //
// ./src/constants/shipment.js